var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mapbase',{attrs:{"mapColor":_vm.mapColor,"mapTitle":_vm.mapTitle,"mapName":_vm.mapName,"unit":_vm.unit,"pieces":_vm.pieces,"cityD":_vm.cityD,"provicesD":_vm.provicesD}})}
var staticRenderFns = []

export { render, staticRenderFns }